import { createCustomEnum } from "./customEnum";

const Processors = createCustomEnum({
	TSYS: {
		value: 2,
		name: "TSYS",
		displayName: "TSYS",
	},
	_360Payments: {
		value: 33,
		name: "360Payments",
		displayName: "360 Payments",
	},
	FiservOmahaFSP: {
		value: 1,
		name: "FiservOmahaFSP",
		displayName: "Fiserv Omaha FSP",
	},
	FiservNorth: {
		value: 5,
		name: "FiservNorth",
		displayName: "Fiserv North",
	},
	FiservOmahaRetail: {
		value: 19,
		name: "FiservOmahaRetail",
		displayName: "Fiserv Omaha Retail",
	},
	Elavon: {
		value: 20,
		name: "Elavon",
		displayName: "Elavon",
	},
	PaymentAdvisors: {
		value: 21,
		name: "PaymentAdvisors",
		displayName: "Payment Advisors",
	},
	FiservConcord: {
		value: 22,
		name: "FiservConcord",
		displayName: "Fiserv Concord",
	},
	Evo: {
		value: 23,
		name: "Evo",
		displayName: "Evo",
	},
	Powerpay: {
		value: 24,
		name: "Powerpay",
		displayName: "Powerpay",
	},
	MBN: {
		value: 25,
		name: "MBN",
		displayName: "MBN",
	},
	Cardflex: {
		value: 26,
		name: "Cardflex",
		displayName: "Cardflex",
	},
	Transfirst: {
		value: 27,
		name: "Transfirst",
		displayName: "Transfirst",
	},
	BankcardUSA: {
		value: 28,
		name: "BankcardUSA",
		displayName: "Bankcard USA",
	},
	NorthAmericaBankcardNAB: {
		value: 29,
		name: "NorthAmericaBankcardNAB",
		displayName: "North America Bankcard (NAB)",
	},
	FiservCanada: {
		value: 30,
		name: "FiservCanada",
		displayName: "Fiserv Canada",
	},
	LegacyProcessor: {
		value: 32,
		name: "LegacyProcessor",
		displayName: "Legacy Processor",
	},
});

export default Processors;
